<div class="drawer-panel" [class.resizing]="isResizing" role="dialog" aria-modal="true" [attr.aria-label]="config.title">

    @if (config.resizable) {
        <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>
    }

    <!-- Botón X flotante a la izquierda del panel -->
    <button class="close-tab" mat-mini-fab color="warn" (click)="onCloseF()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>

    <!-- Header -->
    <header class="drawer-header">
        <div class="drawer-header__text">
            @if (config.title) {
            <h2 class="drawer-title">{{ config.title }}</h2>
            }
            @if (config.subtitle) {
            <p class="drawer-subtitle">{{ config.subtitle }}</p>
            }
        </div>
    </header>

    <!-- Contenido dinámico vía TemplateRef -->
    <div class="drawer-body">
        @if (config.content) {
        <ng-container [ngTemplateOutlet]="config.content"
            [ngTemplateOutletContext]="config.contentContext ?? {}" />
        }
    </div>

    <!-- Footer solo con botones de acción -->
    @if (visibleButtons.length > 0) {
    <footer class="drawer-footer">
        @for (btn of visibleButtons; track btn.label) {
        <button class="drawer-btn" [class]="'drawer-btn drawer-btn--' + (btn.variant ?? 'primary')"
            [disabled]="btn.disabled ?? false" (click)="onButtonClick(btn)">
            {{ btn.label }}
        </button>
        }
    </footer>
    }

</div>
